import api from '../../api/index.js'

const state = {
    
}

const getters = {

}

const actions = {
    GetDefalut({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/MemberAddress/GetDefalut',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    }
}

const mutations = {
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/memberAddress.js